// Lightweight metrics reporter, used in dev to see baseline FPS / INP / LCP.
// In prod we POST to the worker for aggregation (cheap, fire-and-forget).
//
// Activated by ?perf=1 query param OR DEV mode. Otherwise no-op.

import { onINP, onLCP, onCLS, onFCP, onTTFB, type Metric } from "web-vitals";

function enabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return new URLSearchParams(location.search).get("perf") === "1";
  } catch {
    return false;
  }
}

function logMetric(m: Metric): void {
  // eslint-disable-next-line no-console
  console.log(`[perf] ${m.name} ${Math.round(m.value)}${m.name === "CLS" ? "" : "ms"}`);
}

let frames = 0;
let lastFlush = performance.now();

function fpsTick(): void {
  frames++;
  const now = performance.now();
  if (now - lastFlush > 2000) {
    const fps = Math.round((frames * 1000) / (now - lastFlush));
    // eslint-disable-next-line no-console
    console.log(`[perf] FPS ~${fps}`);
    frames = 0;
    lastFlush = now;
  }
  requestAnimationFrame(fpsTick);
}

function watchLongTasks(): void {
  if (typeof PerformanceObserver === "undefined") return;
  try {
    const po = new PerformanceObserver((list) => {
      for (const e of list.getEntries()) {
        // eslint-disable-next-line no-console
        console.warn(`[perf] long task ${Math.round(e.duration)}ms`);
      }
    });
    po.observe({ entryTypes: ["longtask"] });
  } catch {
    /* not supported */
  }
}

export function installPerf(): void {
  if (!enabled()) return;
  onINP(logMetric);
  onLCP(logMetric);
  onCLS(logMetric);
  onFCP(logMetric);
  onTTFB(logMetric);
  watchLongTasks();
  requestAnimationFrame(fpsTick);
}
